/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                $(window).on("load resize", function equalHeights() {
                    $('.row').each(function() {
                        var highestBox = 0;
                        $(this).find('.match-height').css("min-height", 0);
                        $(this).find('.match-height').each(function() {
                            if ($(this).outerHeight() > highestBox) {
                                highestBox = $(this).outerHeight();
                            }
                        });
                        $(this).find('.match-height').css("min-height", highestBox);
                    });
                }).resize();

                function createMoreMenu(menu, width) {
                    if ($(window).width() > width) { //get body width without(!) scrollbar
                        var w = 0;
                        var mw = $(menu).parent().width() - $('#lang_sel').outerWidth() - 76; //100 = width of 'more' item
                        var menuhtml = '';
                        $(menu).children().each(function() {
                            w += $(this).outerWidth(true);
                            if (mw < w && !$(this).find('a').hasClass('more')) {
                                menuhtml += $('<div>').append($(this).clone()).html();
                                $(this).remove();
                            }
                        });
                        if (menuhtml) {
                            $(menu + " .dropdown.more>ul").html('');
                            $(menu + " .dropdown.more>ul").append(menuhtml);
                            $(menu + " .dropdown.more").removeClass('hidden-lg-up').removeClass('hidden-lg-down');
                        }
                    }
                }

                $('header ul.more').each(function() {
                    var menu = '#' + $(this).attr('id');
                    var width = $(this).data('breakpoint') || 1025;
                    var originalMenu = $(menu).clone();
                    createMoreMenu(menu, width);
                    $(menu).removeClass('vh');
                    $(originalMenu).removeClass('vh');
                    $(window).on("resize", function() {
                        $(menu).replaceWith(originalMenu.clone());
                        createMoreMenu(menu, width);
                    });
                });

                /*$('.gallery').flickity({
                  contain: true,
                  wrapAround: true,
                  cellAlign: 'left'
                });*/
                //new WOW().init();

                $('#banner').owlCarousel({
                    loop: true,
                    margin: 0,
                    autoplay:true,
                    autoplayTimeout:7000,
                    autoplayHoverPause:false,
                    pagination: false,
                    nav: false,
                    items: 1
                });


                $('#slider').owlCarousel({
                    loop: true,
                    margin: 0,
                    nav: true,
                    items: 1
                });

                $('#news').owlCarousel({
                    loop: false,
                    margin: 30,
                    nav: true,
                    responsive:{
                        0:{
                            items:1
                        },
                        1200:{
                            items:3
                        },
                        1500:{
                            items:2
                        }
                    }
                });

                $('a.scroll').click(function(e) {
                  e.preventDefault();
                  $('html, body').animate({
                      scrollTop: $("section.news-items").offset().top - 80
                  }, 300);
                });


            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
                $(".nav-toggle").click(function(event) {
                    var scrollHeight = $(window).scrollTop();
                    $(".nav-wrapper, .nav-toggle, body").toggleClass("open");
                    event.preventDefault();
                    if ($('.nav-toggle').hasClass('open')) {
                        $('.nav-toggle').attr('data-height', scrollHeight);
                    } else {
                        $(window).scrollTop($('.nav-toggle').attr('data-height'));
                    }
                });

                //$(".archive .wblock").stick_in_parent({'offset_top':50});

                $( '.nav-link' ).click(function(e){
                  e.preventDefault();
                  var element = $(this);
                  var elementhref = event.target.href;
                  var url = elementhref.substr(0,elementhref.indexOf('#'));
                  var counturllength = url.length;
                  var urllength = counturllength + 1;
                  var elementhrefwithouthash = elementhref.substr(urllength,elementhref.indexOf('#'));
                  var linkedElement = $("#" + elementhrefwithouthash);

                  if($('.active').length>0){

                    $('.active').removeClass('active');
                  }

                  element.addClass('active');
                  linkedElement.addClass('active');
                });
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
